var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_28966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7C11.875 8.29293 11.3614 9.53291 10.4471 10.4471C9.53291 11.3614 8.29293 11.875 7 11.875C5.70707 11.875 4.46709 11.3614 3.55285 10.4471C2.63861 9.53291 2.125 8.29293 2.125 7C2.125 5.70707 2.63861 4.46709 3.55285 3.55285C4.46709 2.63861 5.70707 2.125 7 2.125C8.29293 2.125 9.53291 2.63861 10.4471 3.55285C11.3614 4.46709 11.875 5.70707 11.875 7ZM1 7C1 8.5913 1.63214 10.1174 2.75736 11.2426C3.88258 12.3679 5.4087 13 7 13C8.5913 13 10.1174 12.3679 11.2426 11.2426C12.3679 10.1174 13 8.5913 13 7C13 5.4087 12.3679 3.88258 11.2426 2.75736C10.1174 1.63214 8.5913 1 7 1C5.4087 1 3.88258 1.63214 2.75736 2.75736C1.63214 3.88258 1 5.4087 1 7ZM6.4375 3.8125V7C6.4375 7.1875 6.53125 7.36328 6.68828 7.46875L8.93828 8.96875C9.19609 9.14219 9.54531 9.07187 9.71875 8.81172C9.89219 8.55156 9.82187 8.20469 9.56172 8.03125L7.5625 6.7V3.8125C7.5625 3.50078 7.31172 3.25 7 3.25C6.68828 3.25 6.4375 3.50078 6.4375 3.8125Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_28966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.255ef2831994bd92e97fb3da54a36dd5.svg";
export { ForwardRef as ReactComponent };